import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

// import { Box, TextField, Stepper, Step, StepLabel } from "@mui/material";
// import { statusNewNames } from '../../utils/StatusUtils';
// import "../../css/Inbound.css";
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfTemplate from './PdfTemplate';
const ModalGenerateCartPdf = ({ open, onClose, selectedRowInbound }) => {
    // console.log("ModalGenerateCartPdf", selectedRowInbound);

    return (
        selectedRowInbound  && selectedRowInbound != null?
            <Dialog open={open} onClose={onClose}>
                {/* <DialogTitle>Generar carta de instrucción</DialogTitle> */}
                <DialogContent>

                    <h2 className="text-2xl font-bold mb-3 text-center text-gray-800">Carta de Instrucciones</h2>
                    <p className="mb-4 text-center text-gray-600 text-base">
                        Esta carta contiene información importante sobre el embarque. Envíela al transportista.
                    </p>

                    <div className="mb-6 p-4 bg-gray-100 rounded-lg">
                        <h3 className="font-semibold mb-2 text-gray-700">Datos del transportista:</h3>
                        <div className="space-y-1">
                            <p className="flex items-center text-sm">
                                <svg className="w-4 h-4 mr-2 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                <span>{selectedRowInbound ? selectedRowInbound.operador_email : 'No disponible'}</span>
                            </p>
                            <p className="flex items-center text-sm">
                                <svg className="w-4 h-4 mr-2 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.27-1.27a1 1 0 01 2.11-.45l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                                <span>{selectedRowInbound ? selectedRowInbound.operador_telefono : 'No disponible'}</span>
                            </p>
                        </div>
                    </div>


                </DialogContent>
                <DialogActions sx={{
                    display: 'flex',
                    justifyContent: 'center', // Centra los botones
                    paddingBottom: 2, // Espaciado inferior
                }}>

                    <div className="grid grid-cols-2 gap-4 mt-8">
                        <PDFDownloadLink
                            document={
                                <PdfTemplate
                                    selectedRowInbound={selectedRowInbound}
                                />}
                                fileName={`CartaDeInstruccion${selectedRowInbound.referencia}.pdf`}
                            className="flex items-center justify-center px-6 py-3 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-100 transition-colors shadow-sm font-medium"
                        >
                            {({ loading }) =>
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                    </svg>
                                    {loading ? "Preparando..." : "Solo descargar"}
                                </>
                            }
                        </PDFDownloadLink >

                        <button
                            className="flex items-center justify-center px-6 py-3 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors shadow-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                        // onClick={handleSendNotification}
                        // disabled={isLoading || (!completeShipmentData.transporterEmail && !transporterPhone)}

                        >


                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18-9-2zm0 0v-8" />
                                </svg>
                                Notificar
                            </>
                        </button>

                    </div>


                </DialogActions>
            </Dialog> : "none"
    );
};

export default ModalGenerateCartPdf;
